import calendar from "@/assets/js/calendar";

export default {
    //判断手机机型
    versions () {
        var u = navigator.userAgent;
        return {
            trident: u.indexOf('Trident') > -1,
            presto: u.indexOf('Presto') > -1,
            webKit: u.indexOf('AppleWebKit') > -1,
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,
            mobile: !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/),
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
            iPhone: u.indexOf('iPhone') > -1,
            iPad: u.indexOf('iPad') > -1,
            iPod: u.indexOf('iPod') > -1,
            webApp: u.indexOf('Safari') == -1
        };
    },
    //设置缓存
    setItem (key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    // 获取缓存
    getItem (key) {
        return JSON.parse(localStorage.getItem(key));
    },
    // 清除所有缓存
    clearAll () {
        localStorage.clear();
    },
    //清除指定缓存
    clearAppoint (key) {
        localStorage.removeItem(key);
    },
    toChies(num) {
        var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
        var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千','万', '十', '百', '千','亿'];//可继续追加更高位转换值
        if(!num || isNaN(num)){
            return "零";
        }
        var english = num.toString().split("")
        var result = "";
        for (var i = 0; i < english.length; i++) {
            var des_i = english.length - 1 - i;//倒序排列设值
            result = arr2[i] + result;
            var arr1_index = english[des_i];
            result = arr1[arr1_index] + result;
        }
        //将【零千、零百】换成【零】 【十零】换成【十】
        result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
        //合并中间多个零为一个零
        result = result.replace(/零+/g, '零');
        //将【零亿】换成【亿】【零万】换成【万】
        result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
        //将【亿万】换成【亿】
        result = result.replace(/亿万/g, '亿');
        //移除末尾的零
        result = result.replace(/零+$/, '')
        //将【零一十】换成【零十】
        //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
        //将【一十】换成【十】
        result = result.replace(/^一十/g, '十');
        return result;
    },
    year () {
        let year = new Date().getFullYear() + 1;
        let arr = [];
        for (let i = 1900; i < year; i++) {
            arr.unshift({ key: i, val: calendar.toGanZhiYear(i) + calendar.getAnimal(i) })
        }
        return arr;
    },
    month (y) {
        let arr = []
        for (let i = 0; i < 12; i++) {
            arr.push({ key: i + 1, val: calendar.toChinaMonth(i + 1) })
        }
        return arr;
    },
    day (year, month) {
        let day = new Date(year, month, 0).getDate();
        let arr = [];
        for (let i = 0; i < day; i++) {
            arr.push({ key: i + 1, val: calendar.toChinaDay(i + 1) })
        }
        return arr;
    },
    adultHeight () {
        let data = [];
        for (let i = 110; i <= 250; i++) {
            data.push(i)
        }
        return data;
    },
    formData () {
        let data = {
            relation: "",
            familyid: '',
            fatherid: 0,
            onceid: 1,
            // avator: "",
            avatorinfo: [],
            type: 0,
            ischange: 0,
            sfqx: 0,
            xm: "",
            cxm: "",
            gmyy: "",
            zi: "",
            hao: "",
            shixu: "",
            bfdjz: "",
            bfyz: "",
            ph: "",
            sex: 0,
            srlx: 0,
            cd: "",
            nh: "",
            sr: "",
            nlsr: "",
            mz: "",
            gmzr: 0,
            sheng: "",
            shi: "",
            xian: "",
            dtdz: "",
            zdydz: "",
            sgzt: 0,
            hyzt: 0,
            kfgrxx: "",
            sx: "",
            sg: "",
            xx: "",
            xueli: "",
            xw: "",
            dp: "",
            zj: "",
            occupation: [{ gzdw:"",zw:"",zwjb:"",zc:"",zcjb:"",scxj:"" }],
            previous: [{ zy: '' }],
            kfscxx: "",
            qssj: "",
            qssheng: "",
            qsshi: "",
            qsxian: "",
            qsdz: "",
            qsdtdz: "",
            qszdydz: "",
            qsxxdz: "",
            qsyy: "",
            qsnian: '',
            ycbs: "",
            mzdz: "",
            mzdtdz: "",
            mzzdydz: "",
            mzxxdz: "",
            mzfw: "",
            sflb: 0,
            inout: 1,
            qsinout: 1,
            riqi: "",
            qssjlx: 0,
            qscd: "",
            qsnh: "",
            qssr: "",
            azfs: 0,
            migrationList: [
            ],
            spouseList: []
        };
        return data;
    },
    mData () {
        return {
            cd: "",
            nh: "",
            nlriqi: "",
            qccun: "",
            qcdizhi: "",
            qcdtdz: "",
            qcinorout: "",
            qcsheng: "",
            qcshi: "",
            qcxian: "",
            qczdydz: "",
            qczhen: "",
            qrcun: "",
            qrdizhi: "",
            qrdtdz: "",
            qrinorout: "",
            qrsheng: "",
            qrshi: "",
            qrxian: "",
            qrzdydz: "",
            qrzhen: "",
            riqi: "",
            rqlx: 0,
            sdlr: ""
        }
    },
    sData () {
        return {
            pezt: 0, // 配偶状态
            pexb: 1, // 0男 1女
            hyzt: 0, // 0结婚 1离异
            hyfs: '',
            pexm: "", // 配偶姓名
            cym: "", // 曾用名
            jgsheng: "", // 籍贯省
            jgshi: "", // 籍贯市
            jgxian: "", // 籍贯县
            dizhi: "", // 地址
            fqxm: "", // 父亲姓名
            fqph: "", // 父亲排行
            glsr: "", // 公历生日
            nlsr: "", // 农历生日
            srlx:0,
            cssheng: "", // 出生省
            csshi: "", // 出生市
            csxian: "", // 出生县
            csdizhi: "", // 出生地址
            shuxiang: "", // 属相
            shengao: "", // 身高
            xuexing: "", // 血型
            xueli: "", // 学历
            xuewei: "", // 学位
            dangpai: "", // 党派
            zongjiao: "", // 宗教
            occupation: [{ gzdw:"",zw:"",zwjb:"",zc:"",zcjb:"",scxj:"" }],
            previous: [{ zy: '' }],
            intro: "", // 生平介绍
            sfsy:1,// 是否生育
            ezs: "", // 儿子数
            ezxm: "", // 儿子姓名，多个用,隔开
            nes: "", // 女儿数
            jginorout: 1,
            jgzhen: '',
            jgzdydz: '',
            jgdtdz: '',
            jzsheng: "", // 居住省
            jzshi: "", // 居住市
            jzxian: "", // 居住县
            jzd: "", // 居住地
            dtdz: "", // 地图地址
            zdydz: "", // 自定义地址
            xxdz: "", // 详细地址
            qssj: "", // 去世时间
            qsnlsr: "", // 去世弄咯时间
            qssjlx:0,
            qscd: "", // 去世朝代
            qsnh: "", // 去世年号
            ycbs: "", // 遗传病史
            sflb: 0 // 是否立碑 0是 1否
        }
    },
    zwhbTypeData () {
        return ['国家级正职', '国家级副职', '省部级正职', '省部级副职', '厅局级正职', '厅局级副职', '县处级正职', '县处级副职', '乡科级正职', '乡科级副职', '科员级', '办事员级',];
    },
    // 最高（或现任）职务级别字库：
    zwjbData () {
        let data = [
            {
                val: '地方职级',
                "children": [{ val: '国家级正职', }, { val: '国家级副职', }, { val: '省部级正职', }, { val: '省部级副职', }, { val: '厅局级正职', }, { val: '厅局级副职', }, { val: '县处级正职', }, { val: '县处级副职', }, { val: '乡科级正职', }, { val: '乡科级副职', }, { val: '科员级', }, { val: '办事员级' }]
            }, {
                val: '军队职级',
                "children": [{ val: '中央军委正职', }, { val: '中央军委副职', }, { val: '大军区（战区）正职', }, { val: '大军区（战区）副职', }, { val: '正军职', }, { val: '副军职', }, { val: '正师职', }, { val: '副师职', }, { val: '正团职', }, { val: '副团职', }, { val: '正营职', }, { val: '副营职', }, { val: '正连职', }, { val: '副连职', }, { val: '正排职', }, { val: '副排职' }]
            }]
        return data;
    },
    zyData(){
        let data = [
            {
                val: '农民',
                "children": [{ val: '务农（在世人员）' },{ val: '一生务农（去世人员）' },{ val: '大规模种植户' },{ val: '农民专业合作社' },{ val: '养殖业' },{ val: '养殖大户' },{ val: '畜牧业' },{ val: '水产业' },{ val: '菜农' },{ val: '茶农' },{ val: '果农' },{ val: '棉农' },{ val: '林农' },{ val: '蜂农' },{ val: '蚕农' }]
            }, {
                val: '工人',
                "children": [{ val: '工人' },{ val: '退休工人' },{ val: '技术工人' },{ val: '国企工人' },{ val: '私企工人' },{ val: '建筑工人' },{ val: '驾驶员' },{ val: '修理工' },{ val: '铸造工' },{ val: '木工' },{ val: '车工' },{ val: '钳工' },{ val: '磨工' },{ val: '铣工' },{ val: '电工' },{ val: '电气焊工' },{ val: '热处理工' },{ val: '电力工' },{ val: '采矿工' },{ val: '安装工' },{ val: '爆破工' },{ val: '挖掘机工' },{ val: '纺织工' },{ val: '机修工' },{ val: '操作工' },{ val: '园艺工人' }]
            }, {
                val: '无业',
                "children": [{ val: '无业' },{ val: '待业' },{ val: '家庭妇女' }]
            }, {
                val: '国家公务员',
                "children": [{ val: '退休机关干部' },{ val: '离休机关干部' },{ val: '国家公务员' },{ val: '国家机关公务员' },{ val: '省直机关公务员' },{ val: '地市机关公务员' },{ val: '区县机关公务员' },{ val: '乡镇机关公务员' }]
            }, {
                val: '事业单位',
                "children": [{ val: '事业单位' },{ val: '事业单位退休干部' },{ val: '事业单位离休干部' },{ val: '国家直属事业单位' },{ val: '省级直属事业单位' },{ val: '地市直属事业单位' },{ val: '区县直属事业单位' },{ val: '乡镇直属事业单位' }]
            }, {
                val: '专业技术人员',
                "children": [{ val: '科学研究人员' },{ val: '工程技术人员' },{ val: '农业技术人员' },{ val: '渔业技术人员' },{ val: '畜牧业技术人员' },{ val: '地质业技术人员' },{ val: '矿产业技术人员' },{ val: '建筑技术人员' },{ val: '飞机技术人员' },{ val: '船舶技术人员' },{ val: '汽车技术人员' },{ val: '卫生专业技术人员' },{ val: '经济专业人员' },{ val: '金融专业人员' },{ val: '法律专业人员' },{ val: '社会专业人员' },{ val: '宗教专业人员' },{ val: '教学人员' },{ val: '文艺工作者' },{ val: '体育专业人员' },{ val: '新闻出版专业人员' },{ val: '文化专业人员' },{ val: '计算机专业技术人员' },{ val: '软件工程师' }]
            }, {
                val: '教育业',
                "children": [{ val: '教育业' },{ val: '教师' },{ val: '退休教师' },{ val: '大学教师' },{ val: '职教教师' },{ val: '中学教师' },{ val: '小学教师' },{ val: '幼儿教师' },{ val: '大学校长' },{ val: '中学校长' },{ val: '小学校长' },{ val: '幼儿园园长' },{ val: '大学科研人员' },{ val: '大学管理人员' },{ val: '教学辅助人员' },{ val: '教学专业技术人员' }]
            }, {
                val: '学生',
                "children": [{ val: '幼儿阶段' },{ val: '幼儿园学生' },{ val: '在校小学生' },{ val: '在校中学生' },{ val: '在校大学生' },{ val: '在校硕士研究生' },{ val: '在校博士研究生' },{ val: '出国留学生' }]
            }, {
                val: '商业',
                "children": [{ val: '供销社干部' },{ val: '供销社职工' },{ val: '国营商业' },{ val: '私营商业' },{ val: '个体经营' },{ val: '个体超市' },{ val: '私营超市' },{ val: '电商人员' },{ val: '批发零售业' },{ val: '百货批发业' },{ val: '国际贸易' },{ val: '商场' },{ val: '超市' },{ val: '大型综合超市' },{ val: '专卖店' }]
            }, {
                val: '企业',
                "children": [{ val: '国有企业' },{ val: '军工企业' },{ val: '国有企业管理人员' },{ val: '国有企业技术人员' },{ val: '国有企业职工' },{ val: '外资企业' },{ val: '外资企业管理人员' },{ val: '外资企业技术人员' },{ val: '外资企业职工' },{ val: '合资企业' },{ val: '合资企业管理人员' },{ val: '合资企业技术人员' },{ val: '合资企业职工' },{ val: '独资企业管理人员' },{ val: '独资企业技术人员' },{ val: '独资企业职工' },{ val: '私营企业' },{ val: '私营企业管理人员' },{ val: '私营企业技术人员' },{ val: '私营企业职工' },{ val: '全民所有制企业' },{ val: '全民所有制企业管理人员' },{ val: '全民所有制企业技术人员' },{ val: '全民所有制企业职工' },{ val: '集体所有制企业' },{ val: '集体所有制企业管理人员' },{ val: '集体所有制企业技术人员' },{ val: '集体所有制企业职工' },{ val: '股份制企业' },{ val: '股份制企业管理人员' },{ val: '股份制企业技术人员' },{ val: '股份制企业职工' },{ val: '有限责任企业' },{ val: '有限责任企业管理人员' },{ val: '有限责任企业技术人员' },{ val: '有限责任企业职工' }]
            }, {
                val: '医务工作者',
                "children": [{ val: '医务工作者' },{ val: '医师' },{ val: '乡村医生' },{ val: '中医师' },{ val: '军医' },{ val: '药剂师' },{ val: '化验员' },{ val: '护士' },{ val: '护士长' },{ val: '护理部主任' },{ val: '科主任' },{ val: '医院技术人员' },{ val: '医院管理人员' },{ val: '医学科研人员' },{ val: '防疫工作者' }]
            }, {
                val: '畜牧兽医工作者',
                "children": [{ val: '畜牧兽医' },{ val: '畜禽检疫人员' },{ val: '畜禽疾病防控人员' },{ val: '畜禽饲料研发人员' },{ val: '畜禽兽药研发人员' },{ val: '畜禽兽药经营人员' }]
            }, {
                val: '餐饮住宿旅游业',
                "children": [{ val: '旅游业' },{ val: '餐饮业' },{ val: '旅馆业' },{ val: '餐饮住宿业' },{ val: '个体饭店' },{ val: '个体宾馆' }]
            }, {
                val: '渔业',
                "children": [{ val: '渔民' },{ val: '海洋渔业' },{ val: '淡水渔业' },{ val: '渔业生产' },{ val: '渔业捕捞' },{ val: '渔业养殖' },{ val: '渔业销售' },{ val: '渔业冷藏与销售' },{ val: '渔具生产' },{ val: '渔具销售' }]
            }, {
                val: '文学艺术界',
                "children": [{ val: '作家' },{ val: '诗人' },{ val: '剧作家' },{ val: '散文家' },{ val: '小说家' },{ val: '文学评论家' },{ val: '杂文家' },{ val: '画家' },{ val: '演员' },{ val: '雕塑家' },{ val: '音乐家' },{ val: '歌唱家' },{ val: '歌唱演员' },{ val: '舞蹈家' },{ val: '舞蹈演员' },{ val: '设计师' },{ val: '导演' },{ val: '记者' },{ val: '主持人' },{ val: '广播电视台' }]
            }, {
                val: '党派社团',
                "children": [{ val: '民主党派' },{ val: '工商联' },{ val: '行业学会' },{ val: '行业协会' },{ val: '宗教事务管理' },{ val: '宗教团体' },{ val: '宗教教职人员' },{ val: '宗教场所工作人员' }]
            }, {
                val: '金融行业',
                "children": [{ val: '金融业' },{ val: '银行业' },{ val: '保险业' },{ val: '证券业' },{ val: '信托业' },{ val: '租赁业' }]
            }, {
                val: '交通运输业',
                "children": [{ val: '交通运输业' },{ val: '铁路运输业' },{ val: '航空运输业' },{ val: '公路运输业' },{ val: '船舶运输业' },{ val: '管道运输业' }]
            }, {
                val: '电力业',
                "children": [{ val: '国家电网' },{ val: '南方电网' },{ val: '火力发电业' },{ val: '太阳能发电业' },{ val: '核能发电业' },{ val: '风力发电业' },{ val: '氢能发电业' },{ val: '水力发电业' },{ val: '电力输送业' },{ val: '供电行业' },{ val: '电力工程施工' },{ val: '电力堪察设计' },{ val: '电力科研' },{ val: '电力分配销售' }]
            }, {
                val: '建筑与房地产业',
                "children": [{ val: '建筑业' },{ val: '房地产业' },{ val: '房地产开发业' },{ val: '房地产经营' },{ val: '物业公司' },{ val: '土木工程建筑业' },{ val: '房屋建设业' },{ val: '建筑安装业' },{ val: '建筑装饰业' },{ val: '建筑设计业' },{ val: '建材生产加工业' },{ val: '建材经营业' },{ val: '建筑工程' },{ val: '公路工程' },{ val: '铁路工程' },{ val: '民航机场工程' },{ val: '港口与航道工程' },{ val: '水利水电工程' },{ val: '矿业工程' },{ val: '机电工程' },{ val: '市政公用工程' },{ val: '通信与广电工程' }]
            }, {
                val: '社会生产生活服务业',
                "children": [{ val: '批发与零售业' },{ val: '物流业' },{ val: '仓储业' },{ val: '邮政业' },{ val: '电信业' },{ val: '通信业' },{ val: '住宿和餐饮业' },{ val: '美容美发业' },{ val: '洗浴中心' },{ val: '信息传输业' },{ val: '软件和信息技术业' },{ val: '保险服务人员' },{ val: '房地产服务人员' },{ val: '租赁和商务服务人员' },{ val: '技术辅助服务人员' },{ val: '环卫管理服务人员' },{ val: '公共设施管理服务人员' },{ val: '居民服务人员' },{ val: '燃气公司' },{ val: '自来水公司' },{ val: '修理及制作服务人员' },{ val: '文化服务人员' },{ val: '体育服务人员' },{ val: '娱乐服务人员' },{ val: '健康服务人员' }]
            }, {
                val: '生产加工服务业',
                "children": [{ val: '钢铁行业' },{ val: '制药业' },{ val: '保健品业' },{ val: '农副产品加工业' },{ val: '食品加工业' },{ val: '饮料加工业' },{ val: '酒厂' },{ val: '木材加工业' },{ val: '家具及木制品业' },{ val: '编织品业' },{ val: '纺织品业' },{ val: '烟草加工业' },{ val: '服装加工业' },{ val: '毛皮制品加工业' },{ val: '皮革制品加工业' },{ val: '纸制品加工业' },{ val: '文教用品加工业' },{ val: '体育用品加工业' },{ val: '娱乐用品加工业' },{ val: '儿童用品加工业' },{ val: '老年用品加工业' },{ val: '出版业' },{ val: '印刷业' },{ val: '石油化工业' },{ val: '化学制品业' },{ val: '汽车制造业' },{ val: '汽车维修业' },{ val: '玻璃制造业' },{ val: '设备制造业' },{ val: '废旧物品回收业' },{ val: '仪器、仪表业' },{ val: '化纤业' },{ val: '橡胶业' }]
            }, {
                val: '军人',
                "children": [{ val: '现役军人' },{ val: '退役军人' },{ val: '复员军人' },{ val: '转业军人' },{ val: '残疾军人' },{ val: '革命烈士' },{ val: '因公牺牲军人' },{ val: '军队文职人员' }]
            }]
            return data;
    },
    // 最高（或现任）职称级别字库：
    zcjbData () {
        let data = ['正高级', '副高级', '中级', '初级'];
        return data;
    },
    // 最高（或现任）专业技术职称
    jjzcData () {
        let data = ['军衔', '武警警衔', '民警警衔', '海关关衔', '消防救援衔', '外交衔'];
        return data;
    },
    //最高（或现任）专业技术职称级别
    jjzcjbData () {
        let data = [
            {
                val: '军衔',
                "children": [{ val: '元帅' }, { val: '大将' }, { val: '上将' }, { val: '中将' }, { val: '少将' }, { val: '准将' }, { val: '大校' }, { val: '中校' }, { val: '少校' }, { val: '大尉' }, { val: '上尉' }, { val: '中尉' }, { val: '少尉' }, { val: '准尉' }, { val: '一级军士长' }, { val: '二级军士长' }, { val: '三级军士长' }, { val: '四级军士长' }, { val: '上士' }, { val: '中士' }, { val: '下士' }]
            },
            {
                val: '武警警衔',
                "children": [{ val: '武警大将' }, { val: '武警上将' }, { val: '武警中将' }, { val: '武警少将' }, { val: '武警准将' }, { val: '武警大校' }, { val: '武警上校' }, { val: '武警中校' }, { val: '武警少校' }, { val: '武警大尉' }, { val: '武警上尉' }, { val: '武警中尉' }, { val: '武警少尉' }, { val: '武警准尉' }, { val: '武警一级警士长' }, { val: '武警二级警士长' }, { val: '武警三级警士长' }, { val: '武警四级警士长' }, { val: '武警上士' }, { val: '武警中士' }, { val: '武警下士' }]
            }, {
                val: '民警警衔',
                "children": [{ val: '总警监' }, { val: '副总警监' }, { val: '一级警监' }, { val: '二级警监' }, { val: '三级警监' }, { val: '一级警督' }, { val: '二级警督' }, { val: '三级警督' }, { val: '一级警司' }, { val: '二级警司' }, { val: '三级警司' }, { val: '一级警员' }, { val: '二级警员' }]
            }, {
                val: '海关关衔',
                "children": [{ val: '总监' }, { val: '副总监' }, { val: '一级关务监督' }, { val: '二级关务监督' }, { val: '三级关务监督' }, { val: '一级关务督察' }, { val: '二级关务督察' }, { val: '三级关务督察' }, { val: '一级关务督办' }, { val: '二级关务督办' }, { val: '三级关务督办' }, { val: '一级关务员' }, { val: '二级关务员' }]
            }, {
                val: '消防救援衔',
                "children": [{ val: '总监' }, { val: '副总监' }, { val: '助理总监' }, { val: '高级指挥长' }, { val: '一级指挥长' }, { val: '二级指挥长' }, { val: '三级指挥长' }, { val: '一级指挥员' }, { val: '二级指挥员' }, { val: '三级指挥员' }, { val: '四级指挥员' }, { val: '一级消防长' }, { val: '二级消防长' }, { val: '三级消防长' }, { val: '一级消防士' }, { val: '二级消防士' }, { val: '三级消防士' }, { val: '四级消防士' }, { val: '预备消防士' }]
            }, {
                val: '外交衔',
                "children": [{ val: '大使衔' }, { val: '公使衔' }, { val: '参赞衔' }, { val: '一等秘书衔' }, { val: '二等秘书衔' }, { val: '三等秘书衔' }, { val: '随员衔' }]
            }
        ];

        return data;
    },
    // 学历
    xueliData () {
        let data = [ "文盲","识字文化","小学文化","初中文化","高中文化","中专学历","大学专科学历","大学本科学历","研究生学历","【民国】初小文化","【民国】高小文化","【民国】初中文化","【民国】高中文化","【科举】童生","【科举】秀才","【科举】案首","【科举】举人","【科举】解元","【科举】亚元","【科举】贡士","【科举】会元","【科举】进士","【科举】进士及第","【科举】进士出身","【科举】同进士出身","【科举】探花","【科举】榜眼","【科举】状元","【科举】学士","【科举】大学士","【科举】翰林圣士","太学生","国学生","监生","庠生","邑庠生","廪生","私塾文化"];
        return data;
    },
    //职业
    zhiyeData(){
        let data=[ '务农', '工人', '幼儿阶段', '幼儿园学生', '在校小学生', '在校中学生', '在校大学生', '在校研究生', '商业', '供销行业', '个体经商', '养殖业', '林业', '渔业', '国家公务员', '事业单位', '国有企业', '私营企业', '宾馆住宿业', '餐饮业', '交通运输业', '建筑业', '装修装饰业', '采矿业', '印刷业', '制造业', '电力业', '技术服务业', '修理工', '大学教师', '职教教师', '中学教师', '小学教师', '幼儿教师', '科研人员', '工程技术人员', '农业技术人员', '医务工作者', '经济与金融专业人员', '律师', '法官', '检察官', '警察', '文学艺术专业人员', '体育专业人员', '军人', '现役军人' ];
        return data;
    },
    // 年月获取日
    getDaysOfMonth (year, month) {
        switch (month) {
            case 1:
            case 3:
            case 5:
            case 7:
            case 8:
            case 10:
            case 12:
                return 31;
            case 4:
            case 6:
            case 9:
            case 11:
                return 30;
            case 2:
                return ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) ? 29 : 28;
            default:
                return 0;
        }
    },
}



// WEBPACK FOOTER //
// ./src/utils/utils.js